<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12">
        <card>
          <template v-slot:headerTitle>
            <h4 class="card-title"><b>LISTA DE PERSONAS</b></h4>
          </template>
          <div class="text-right px-4 mt-3">
            <button class="mx-1 btn btn-success" @click="$router.push('persona_agregar')"><i class="fas fa-plus"></i>Agregar Persona</button>
          </div>
          <div class="table-responsive px-4 mt-3">
            <table id="datatable_persona" class="table table-bordered table-responsive-md table-striped text-center">
              <thead>
                <tr>
                  <th>Numero Documento</th>
                  <th>Nombre</th>
                  <th>Contraseña reportes</th>
                  <th>Cargo</th>
                  <th>Estado</th>
                  <th>Ver más</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listaItems" :key="item.id">
                  <td>{{ item.numeroDocumento }}</td>
                  <!-- <td><img class="avatar-35 rounded" src="https://www.w3schools.com/w3images/avatar2.png" alt=""></td> -->
                  <td>{{ item.nombres + " " + item.apellidos }}</td>
                  <td>{{ item.contrasenaReportes }}</td>
                  <td>{{ obtenerUbicacionPersona(item) }}</td>
                  <td>
                    <div class="d-flex flex-column">
                      <p>{{ item.estado == 1 ? "Activo" : "Inactivo" }}</p>
                      <div class="toggle-switch" @click="TogglePersonaEstado(item.id)">
                        <input type="checkbox" v-model="item.estado" class="toggle-input" />
                        <label class="toggle-label"></label>
                      </div>
                    </div>
                  </td>
                  <td><b-button v-b-modal.my-modal @click="infoForPerson(item)">Ver más</b-button></td>

                  <!-- <td>
                    <button v-b-modal.modal-1 class="btn btn-secondary">
                      Ver más
                    </button>
                  </td> -->
                  <!-- <b-modal id="bv-modal-example" hide-footer>
                    <template #modal-title>
                      <h6>Informacion de Persona</h6>
                    </template>
                    <div class="d-block text-center">
                      <h3>Hello From This Modal!</h3>
                    </div>
                    <div class="text-right">
                      <b-button
                        class="mt-3"
                        @click="$bvModal.hide('bv-modal-example')"
                        >Cerrar</b-button
                      >
                    </div>
                  </b-modal> -->
                  <td>
                    <div class="d-flex">
                      <vs-button
                        v-b-tooltip="{
                          title: `Registro novedades`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        gradient
                        style="background-color: #6f8ac4"
                        success
                        icon
                        @click="gotoRegistroNovedades(item)"
                      >
                        <i class="fas fa-solid fa-check"></i>
                      </vs-button>
                      <vs-button
                        v-b-tooltip="{
                          title: `Hoja de vida`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        gradient
                        icon
                        @click="$router.push('hoja_vida/' + item.id)"
                      >
                        <i class="fas fa-solid fa-file"></i>
                      </vs-button>
                      <vs-button
                        v-b-tooltip="{
                          title: `historia laboral`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        gradient
                        warn
                        icon
                        @click="$router.push('Persona_historia_laboral/' + item.id)"
                      >
                        <i class="fas fa-solid fa-clock"></i>
                      </vs-button>
                      <vs-button
                        v-b-tooltip="{
                          title: `Editar`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        gradient
                        success
                        icon
                        @click="$router.push('Persona_editar/' + item.id)"
                      >
                        <i class="fas fa-solid fa-pen"></i>
                      </vs-button>
                      <vs-button
                        v-b-tooltip="{
                          title: `Gestionar accesos`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        v-if="persona.rol.nivel == 4"
                        gradient
                        icon
                        danger
                        @click="$router.push('GestionAccesos/' + item.id)"
                      >
                        <i class="fas fa-solid fa-lock"></i>
                      </vs-button>
                    </div>
                    <!-- <div class="row px-2">
                      <div
                        v-b-tooltip="{
                          title: `Registro novedades`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        class="col px-0 mx-0"
                        @click="$router.push('RegistroNovedades/' + item.id)"
                      >
                        <i class="zoom fas fa-solid fa-check px-1 text-light"></i>
                      </div>
                      <div
                        v-b-tooltip="{
                          title: `Hoja de vida`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        class="col px-0 mx-0"
                        @click="$router.push('hoja_vida/' + item.id)"
                      >
                        <i class="zoom fas fa-solid fa-file px-1 text-info"></i>
                      </div>
                      <div
                        v-b-tooltip="{
                          title: `historia laboral`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        class="col px-0 mx-0"
                        @click="$router.push('Persona_historia_laboral/' + item.id)"
                      >
                        <i class="zoom fas fa-solid fa-clock px-1 text-warning"></i>
                      </div>
                      <div
                        v-b-tooltip="{
                          title: `Editar`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        class="col px-0 mx-0"
                        @click="$router.push('Persona_editar/' + item.id)"
                      >
                        <i class="zoom fas fa-solid fa-pen px-1 text-success"></i>
                      </div>
                      <div
                        v-b-tooltip="{
                          title: `Gestionar accesos`,
                          placement: 'top',
                          customClass: 'font_tooltip',
                        }"
                        v-if="persona.rol.nivel == 4"
                        class="col px-0 mx-0"
                        @click="$router.push('GestionAccesos/' + item.id)"
                      >
                        <i class="zoom fas fa-solid fa-lock px-1 text-danger"></i>
                      </div>

                     
                    </div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <b-modal id="my-modal" size="lg" title="Modal title" ok-title="Save Changes" cancel-title="Close">
              <p>Modal body text goes here.</p>
            </b-modal> -->
          <b-modal title="Detalles Persona" id="my-modal" body-bg-variant="dark" header-bg-variant="dark" footer-bg-variant="dark" size="md" hide-footer>
            <h3>Informacion Personal</h3>
            <p>Nombres: {{ infoForPersonData.nombres }}</p>
            <p>Apellidos: {{ infoForPersonData.apellidos }}</p>
            <p>Tipo de Documento: {{ infoForPersonData.tipoDoc }}</p>
            <p>Numero de Documento: {{ infoForPersonData.doc }}</p>
            <p>Estado Civil: {{ infoForPersonData.estadoCivil }}</p>
            <h3>Contacto</h3>
            <p>Direccion: {{ infoForPersonData.direccion }}</p>
            <p>Municipio: {{ infoForPersonData.municipio }}</p>
            <p>Telefono Fijo: {{ infoForPersonData.telFijo }}</p>
            <p>Telefono Movil: {{ infoForPersonData.telMovil }}</p>
            <h3>Seguridad</h3>
            <p>Correo: {{ infoForPersonData.correo }}</p>
            <h3>Empresa</h3>
            <p>Rol en Empresa: {{ infoForPersonData.rol }}</p>
            <p>Empresa: {{ infoForPersonData.empresa }}</p>
            <p>Sucursal: {{ infoForPersonData.sucursal }}</p>
            <p>Area: {{ infoForPersonData.area }}</p>
          </b-modal>
        </card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from "../../../config/pluginInit";
const Swal = require("sweetalert2");
export default {
  name: "DataTable",
  data() {
    return {
      tableName: "Persona",
      listaItems: [],
      persona: {},
      empresaId: "",
      listaPersonaUbicacion: [],
      infoForPersonData: {
        nombres: null,
        apellidos: null,
        tipoDoc: null,
        doc: null,
        estadoCivil: null,
        direccion: null,
        municipio: null,
        telFijo: null,
        telMovil: null,
        correo: null,
        empresa: null,
        rol: null,
        sucursal: null,
        area: null,
      },
    };
  },
  async mounted() {
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.empresaId = this.persona.empresa.id;
    await this.getData();
    await this.getPersonaUbicacion();
    core.index();
    window.$("#datatable_persona").DataTable();
  },
  methods: {
    gotoRegistroNovedades(it) {
      console.log(it);
      if (it.salario == null || it.salario == 0) {
        Swal.fire("Error", "Empleado no tiene salario asignado", "Error");
      } else {
        this.$router.push("RegistroNovedades/" + it.id);
      }
    },
    async infoForPerson(data) {
      console.log(data);
      this.infoForPersonData.nombres = data.nombres;
      this.infoForPersonData.apellidos = data.apellidos;
      this.infoForPersonData.tipoDoc = data.tipoDocumento.descripcion;
      this.infoForPersonData.doc = data.numeroDocumento;
      this.infoForPersonData.estadoCivil = data.estadoCivil.descripcion;
      this.infoForPersonData.direccion = data.direccion;
      this.infoForPersonData.municipio = data.municipio.descripcion;
      this.infoForPersonData.telFijo = data.telefonoFijo;
      this.infoForPersonData.telMovil = data.telefonoMovil;
      this.infoForPersonData.correo = data.correo;
      this.infoForPersonData.rol = data.rol.descripcion;
      this.infoForPersonData.empresa = data.empresa.nombre;
      this.getUbicacionPersonaDatallesModal(data);
    },
    async TogglePersonaEstado(id) {
      Swal.fire({
        title: "Seguro que quiere cambiar el estado?",
        text: "Puede cambiar el estado las veces que lo requiera!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //let loader = this.$loading.show();
          await this.$store.dispatch("hl_get", {
            path: "Persona/TogglePersonaEstado/" + id,
          });
          await this.getData();

          Swal.fire("Listo!", "Se ha cambiado el estado correctamente.", "success");
        }
      });
    },
    obtenerUbicacionPersona(item) {
      let io = this.listaPersonaUbicacion.find((x) => x.persona.id == item.id);
      if (io > 0) {
        let result = this.listaPersonaUbicacion.indexOf(io);
        console.log("cargo ", result);
      }
      return io ? io.cargo.nombre : "";
    },
    getUbicacionPersonaDatallesModal(item) {
      let io = this.listaPersonaUbicacion.find((x) => x.persona.id == item.id);
      // console.log("cargo detalle ", io);
      this.infoForPersonData.sucursal = io.sucursal.descripcion;
      this.infoForPersonData.area = io.area.descripcion;
    },
    async getPersonaUbicacion() {
      try {
        //   console.log("get empresas...");
        let res = await this.$store.dispatch("hl_get", {
          path: "PersonaUbicacion/List/" + this.empresaId,
        });
        console.log("post empresas...", res);
        if (res.length > 0) {
          this.listaPersonaUbicacion = res;
        } else {
          this.listaPersonaUbicacion = [];
        }
      } catch (error) {
        this.listaPersonaUbicacion = [];
        console.log("err", error);
      }
    },
    async getData() {
      console.log(this.persona.empresa.id);
      try {
        console.log("get empresas...");
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/ListPersonaAll/" + this.empresaId,
        });
        //console.log('post empresas...', res)
        if (res.length > 0) {
          this.listaItems = res;
        } else {
          this.listaItems = [];
        }
      } catch (error) {
        this.listaItems = [];
        console.log("err", error);
      }
    },
  },
};
</script>

<style>
/* Estilos para el interruptor */
.toggle-switch {
  position: relative;
  width: 60px;
  height: 34px;
}

/* Estilos para el input oculto */
.toggle-input {
  display: none;
}

/* Estilos para la etiqueta del interruptor (background del interruptor) */
.toggle-label {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  width: 60px;
  height: 34px;
  background-color: #ccc;
  /* Color del fondo cuando está inactivo */
  border-radius: 34px;
  transition: background-color 0.4s;
}

/* Estilos para la etiqueta cuando el interruptor está activado */
.toggle-input:checked + .toggle-label {
  background-color: #2196f3;
  /* Color del fondo cuando está activo */
}

/* Estilos para el indicador (la "perilla" del interruptor) */
.toggle-label::before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 26px;
  height: 26px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.4s;
}

/* Estilos para el indicador cuando el interruptor está activado */
.toggle-input:checked + .toggle-label::before {
  transform: translateX(26px);
}
.font_tooltip {
  font-size: 14px;
  font-style: italic;
}
</style>
